import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight, Loader2, CheckCircle2, ArrowLeft } from "lucide-react";
import { forgotPassword } from "../../api/auth";
import AuthShell, {
  authInputWithIconClass,
  authPrimaryBtnClass,
} from "./AuthShell";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    try {
      await forgotPassword(email);
      setSubmitted(true);
    } catch (err) {
      console.error("Lỗi gửi email:", err);
      alert("Không gửi được email. Vui lòng thử lại.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Khôi phục"
      title="Quên mật khẩu"
      subtitle={
        submitted
          ? "Kiểm tra hộp thư của bạn để tiếp tục."
          : "Nhập email đã đăng ký. Chúng tôi sẽ gửi hướng dẫn đặt lại mật khẩu nếu tài khoản tồn tại."
      }
      brandDescription="Không nhớ mật khẩu? Chỉ cần email đăng ký — hệ thống sẽ gửi liên kết khôi phục an toàn đến hộp thư của bạn."
      footer={
        <p className="text-center text-sm text-stone-500">
          <Link
            to="/login"
            className="inline-flex items-center gap-1.5 font-semibold text-[#8f1219] hover:underline"
          >
            <ArrowLeft size={14} />
            Quay lại đăng nhập
          </Link>
        </p>
      }
    >
      {submitted ? (
        <div className="rounded-2xl border border-emerald-100 bg-emerald-50 px-5 py-6 text-center">
          <CheckCircle2 className="mx-auto mb-3 text-emerald-600" size={36} />
          <p className="text-sm font-semibold text-emerald-800">
            Nếu email tồn tại, hướng dẫn khôi phục đã được gửi.
          </p>
          <p className="mt-2 text-xs text-emerald-700/80">
            Không thấy email? Kiểm tra hộp thư spam hoặc thử lại sau vài phút.
          </p>
        </div>
      ) : (
        <form className="space-y-5" onSubmit={handleSubmit}>
          <div className="flex flex-col gap-1.5">
            <label className="text-sm font-semibold text-stone-700">Email đã đăng ký</label>
            <div className="relative">
              <Mail
                className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-stone-400"
                size={17}
              />
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={authInputWithIconClass}
                placeholder="name@example.com"
                disabled={loading}
              />
            </div>
          </div>

          <button type="submit" disabled={loading} className={authPrimaryBtnClass}>
            {loading ? (
              <>
                <Loader2 size={18} className="animate-spin" />
                Đang gửi...
              </>
            ) : (
              <>
                Gửi yêu cầu
                <ArrowRight size={17} className="transition group-hover:translate-x-0.5" />
              </>
            )}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
